<template>
    <app-layout title="Edit Announcement">
        <form @submit.prevent="submit">
            <page-header>
                <template #title>Edit Announcement</template>

                <template #actions>
                    <jet-button v-show="form.isDirty" type="submit" :disabled="form.processing" >
                        Save
                    </jet-button>

                    <jet-tertiary-button :disabled="form.processing" :href="backUrl">
                        {{ form.isDirty ? 'Cancel' : 'Close' }}
                    </jet-tertiary-button>
                </template>
            </page-header>

            <announcement-form
                :form="form"
                :pricingLevelOptions="pricingLevelOptions"
                class="px-2 md:px-4 lg:px-8"
            />

            <div class="w-full text-center mt-8">
                <jet-danger-button @click="showDeleteModal = true">Delete Announcement</jet-danger-button>
            </div>
        </form>

        <jet-confirmation-modal :show="showDeleteModal" @close="showDeleteModal=false">
            <template #title>
                Delete Announcement
            </template>

            <template #content>
                Are you sure you would like to delete this announcement?
            </template>

            <template #footer>
                <jet-tertiary-button @click="showDeleteModal=false">
                    Cancel
                </jet-tertiary-button>

                <jet-danger-button class="ml-2" @click="deleteAnnouncement" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Delete
                </jet-danger-button>
            </template>
        </jet-confirmation-modal>
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import AnnouncementForm from '@/Pages/Announcements/Partials/AnnouncementForm.vue';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetButton from '@/Jetstream/Button';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';

export default {
    setup(props) {
        const form = useForm({
            id: props.announcement.id,
            pricing_level_ids: props.announcement.pricing_level_ids ? props.announcement.pricing_level_ids.split(',') : [],
            message: props.announcement.message,
        })

        return { form }
    },

    components: {
        AnnouncementForm,
        AppLayout,
        PageHeader,
        JetButton,
        JetConfirmationModal,
        JetDangerButton,
        JetTertiaryButton,

    },

    props: [
        'announcement',
        'pricingLevelOptions'
    ],

    data() {
        return {
            showDeleteModal: false,
        }
    },

    computed: {
        backUrl () {
            const params = route().params;

            if (params.return) {
                return params.return;
            }

            return route('announcements.index', {
                page: this.$page.props.page.announcements,
            });
        },
    },

    methods: {
        submit() {
            if(!this.form.processing) {
                this.form.submit('put', route('announcements.update', {
                    announcement: this.announcement.id,
                }));
            }
        },

        deleteAnnouncement() {
            this.$inertia.delete(route('announcements.destroy', this.announcement.id), null, {
                onError: (errors) => {
                    console.log(errors);
                }
            });
        },
    },
}
</script>

<style scoped>

</style>